import { useEffect, useState } from "react";

import { Monitor, Tablet } from "lucide-react";

import SidonIAssistLogo from "@/assets/logo_SidoniAssist_CNCC.png";
import {
  isAssistDisplayBlocked,
  MIN_SUPPORTED_PHYSICAL_SHORT_SIDE,
  subscribeAssistDisplayGeometry,
} from "@/lib/ui-helper/assist-display";
import { cn } from "@/lib/utils";

const MOBILE_VIEWPORT_BLOCKED_CLASS = "mobile-viewport-blocked";

/**
 * Overlay plein écran si client déclaré mobile ou petit côté d’écran sous le plancher.
 * État initial lu synchrone pour éviter un flash ; verrouille le scroll body.
 */
export function MobileUnsupportedOverlay() {
  const [blocked, setBlocked] = useState(() => isAssistDisplayBlocked());

  useEffect(() => {
    const apply = () => {
      const next = isAssistDisplayBlocked();
      setBlocked(next);
      document.documentElement.classList.toggle(
        MOBILE_VIEWPORT_BLOCKED_CLASS,
        next
      );
    };

    apply();
    const unsubscribe = subscribeAssistDisplayGeometry(apply);
    return () => {
      unsubscribe();
      document.documentElement.classList.remove(MOBILE_VIEWPORT_BLOCKED_CLASS);
    };
  }, []);

  return (
    <div
      className={cn(
        "fixed inset-0 z-200 flex-col items-center justify-center bg-background px-6 py-10",
        blocked ? "flex" : "hidden"
      )}
      role="dialog"
      aria-modal="true"
      aria-hidden={!blocked}
      aria-labelledby="mobile-unsupported-title"
      aria-describedby="mobile-unsupported-description">
      <div className="flex w-full max-w-sm flex-col items-center gap-6 text-center">
        <img
          src={SidonIAssistLogo}
          alt="SidonIAssist"
          className="h-auto w-full max-w-[220px]"
        />

        <div className="flex items-center justify-center gap-4 text-secondary">
          <Tablet className="size-8" aria-hidden />
          <Monitor className="size-8" aria-hidden />
        </div>

        <div className="space-y-3">
          <h1
            id="mobile-unsupported-title"
            className="text-xl font-bold text-foreground">
            Affichage non disponible sur mobile
          </h1>
          <p
            id="mobile-unsupported-description"
            className="text-sm text-muted-foreground leading-relaxed">
            SidonIAssist est conçu pour une utilisation sur{" "}
            <strong className="font-semibold text-foreground">
              tablette ou ordinateur
            </strong>
            . Ouvrez l&apos;application depuis un écran dont le plus petit côté
            atteint au moins {MIN_SUPPORTED_PHYSICAL_SHORT_SIDE} pixels
            (téléphone non supporté).
          </p>
        </div>
      </div>
    </div>
  );
}
